import { useState, useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import Modal from '../../../components/modal/Modal.jsx'
import EditButton from '../../../components/common/buttons/EditButton.jsx'
import useModal from '../../../utils/hooks/useModal.js'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions.js'

import DataTableComp from '../../../components/common/data-table/DataTableComp.jsx'
import MainCommonView from '../../../components/common/MainCommonView.jsx'
import AccountingEntrySalaryConceptForm from './AccountingEntrySalaryConceptForm'
import DataTableAccountSalaryConcepts from '../../../components/accounting-entry/DataTableAccountSalaryConcepts.jsx'

import AccountingEntryService from '../../../services/accounting-entry/accountingEntry.service.js'
import AppSection from '../../../component/layout/AppSection'
import AccountingEntryCommonHeader from '../nav/AccountingEntryCommonHeader'
import EntityDropdown from '../../../component/form/EntityDropdown'
import AppToolbar from '../../../component/layout/AppToolbar'

const AccountingEntrySalaryConcept = () => {
  const { formatMessage: msg } = useIntl()

  const storedCompanyCode = localStorage.getItem('AccountingEntry.companyCode')

  const [companyCode, setCompanyCode] = useState(storedCompanyCode || null)

  // State
  const { isShowing: isShowingEdit, toggle: toggleEdit } = useModal()
  const [currentRowData, setCurrentRowData] = useState(null)
  // Previous
  const previousCompanyCode = useRef(companyCode)
  const previousIsShowingEdit = useRef(isShowingEdit)

  useEffect(() => {
    setCompanyCode(storedCompanyCode || null)
  }, [storedCompanyCode])
  useEffect(() => {
    if (previousCompanyCode.current !== companyCode) dataFacade.reload()
    previousCompanyCode.current = companyCode
  }, [companyCode])
  useEffect(() => {
    if (previousIsShowingEdit.current !== isShowingEdit && !isShowingEdit)
      dataFacade.reload()
    previousIsShowingEdit.current = isShowingEdit
  }, [isShowingEdit])

  const handleRelateConcept = (rowData) => {
    setCurrentRowData(null)
    // console.log(rowData)
    if (rowData) {
      setCurrentRowData(rowData)
    }
    toggleEdit()
  }

  const handleCompanyCodeChange = (value) => {
    setCompanyCode(value)
    localStorage.setItem('AccountingEntry.companyCode', value)
  }

  const dataFacade = useHandlerBasicActions({
    getAll: ({ filter, sort, limit, skip }) => {
      return AccountingEntryService.templates.getTemplates({
        companyCode,
        filter,
        sort,
        limit,
        skip,
      })
    },
  })

  const buttonRelateConcept = (rowData) => (
    <EditButton onClick={() => handleRelateConcept(rowData)} />
  )

  const renderConcepts = (data) =>
    data &&
    data.concepts && <DataTableAccountSalaryConcepts data={data.concepts} />

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable =
    companyCode !== null && companyCode !== undefined ? (
      <DataTableComp
        loading={dataFacade?.loading}
        pagerOptions={pagerOptions}
        tableOptions={{
          className: 'table-accounting-entry-concepts',
          value: dataFacade?.data?.resp,
          ...dataFacade?.sortOptions,
        }}
        autoColumnKey
        columns={[
          <Column
            field="accountCode"
            className="text-monospace"
            header={msg({ id: 'account' })}
            style={{ width: '10%' }}
            sortable
          />,
          <Column
            field="accountName"
            header={msg({ id: 'accountName' })}
            style={{ width: '30%' }}
            sortable
          />,
          <Column
            field="transactionType"
            header={msg({ id: 'criterionDH' })}
            style={{ width: '10%' }}
            body={(rowData) => msg({ id: rowData.transactionType })}
            sortable
          />,
          <Column
            style={{ width: '5%' }}
            field="agrupation.substitutions"
            body={(rowData) => msg({ id: rowData.agrupation.substitutions })}
            header={msg({ id: 'substitutions' })}
          />,
          <Column
            style={{ width: '5%' }}
            field="agrupation.navarra"
            body={(rowData) => msg({ id: rowData.agrupation.navarra })}
            header={msg({ id: 'navarra' })}
          />,
          <Column
            style={{ width: '10%' }}
            field="types"
            header={msg({ id: 'types' })}
            body={(rowData) => rowData?.types?.join(', ')}
          />,
          <Column
            header={msg({ id: 'salaryConcept' })}
            style={{ width: '40%' }}
            body={(rowData) => renderConcepts(rowData)}
          />,
          <Column
            field="_id"
            body={(rowData) =>
              buttonRelateConcept({
                parentId: rowData._id,
                types: rowData?.types,
                agrupation: {
                  substitutions: rowData?.agrupation?.substitutions,
                  navarra: rowData?.agrupation?.navarra,
                },
                transactionType: rowData.transactionType,
                concepts: rowData?.concepts,
                accountCode: rowData?.accountCode,
              })
            }
          />,
        ]}
      />
    ) : null

  const headerTitle = () => {
    if (
      !dataFacade.loading &&
      (companyCode === null || companyCode === undefined)
    )
      return msg({ id: 'accountingEntry.noParam' })
    if (dataFacade?.data?.total === 0) return msg({ id: 'emptyData' })
    return <span className="opacity-25">{dataFacade?.loading && '...'}</span>
  }

  const headerOptions = {
    title: headerTitle(),
    searchOptions: dataFacade?.searchOptions,
    handlerHeaderActions: {
      isDisabledSecondaryButton: dataFacade?.loading,
      secondaryButton: handleRelateConcept,
      secondaryButtonText: 'relateConcept',
      secondaryButtonIcon: 'pi-plus',
    },
  }

  return (
    <AppSection
      header={<AccountingEntryCommonHeader />}
      subheader={
        <AppToolbar
          leftSection={[
            <EntityDropdown
              //   miw={280}
              //   labelh="company"
              entity="accountingEntryCompany"
              value={companyCode}
              onChange={({ value }) => handleCompanyCodeChange(value)}
            />,
          ]}
          rightSection={[]}
        />
      }
      // <AccountingEntryCompanySelector value={companyCode} onChange={(e) => setCompanyCode(e)} />
      headerOptions={headerOptions}
    >
      {dataTable}
      <Modal
        isShowing={isShowingEdit}
        hide={toggleEdit}
        title={msg({ id: 'relateConcept' })}
        context={
          <AccountingEntrySalaryConceptForm
            companyCode={companyCode}
            currentRowData={currentRowData}
            hide={toggleEdit}
          />
        }
      />
    </AppSection>
  )

  return (
    <div className="accounting-entry-salary-concept-container">
      <MainCommonView
        headerOptionsV2={headerOptions}
        componentData={dataTable}
        pagerOptions={pagerOptions}
      />
      <Modal
        isShowing={isShowingEdit}
        hide={toggleEdit}
        title={msg({ id: 'relateConcept' })}
        context={
          <AccountingEntrySalaryConceptForm
            companyCode={companyCode}
            currentRowData={currentRowData}
            hide={toggleEdit}
          />
        }
      />
    </div>
  )
}

export default AccountingEntrySalaryConcept
